/*
 * - Exposes class and methods to interact with the PLSS API
 */

import request, { REQUEST_METHODS } from '@api/Request';
import { PlssEndpoints } from './config';
import { PlssResponse } from './types';
import type { EsriGeometry } from '@api/types';

export default class PlssService {
  public static readonly getPlss = (geometry: EsriGeometry): Promise<PlssResponse> =>
    request({
      url: PlssEndpoints.getPlss(),
      method: REQUEST_METHODS.GET,
      skipAuth: true,
      params: {
        where: '1=1',
        f: 'json',
        geometry: geometry,
        geometryType: 'esriGeometryPoint',
        spatialRel: 'esriSpatialRelIntersects',
        distance: 0,
        inSR: 4326,
        outFields: '*',
      },
    });
}
